import {Component, Input} from '@angular/core';
import {HttpService} from '../../../../../../core';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-new-ar-model',
    templateUrl: 'new-ar-model.component.html',
    styleUrls: ['new-ar-model.component.scss']
})
export class NewArModelComponent{
    @Input() selectedFloorPlanId;
    isIOSModelValid: boolean;
    isAndroidModelValid: boolean;
    iosFile = '';
    androidFile = '';
    isIOSUploading: boolean;
    isAndroidUploading: boolean;

    constructor(private httpService: HttpService,
                private toastrService: ToastrService
                ) {
        console.log(this.selectedFloorPlanId);
    }

    // 当模型文件上传后，检查其合法性
    handleFileChange(event, prefix){
        if (event.target.files && event.target.files[0]){
            if (prefix === 'ios'){
                if (this.isFileNameValid(event.target.files[0], 'ios')){
                    this.iosFile = event.target.files[0];
                    this.isIOSModelValid = true;
                }else {
                    this.isIOSModelValid = false;
                }
            }else if (prefix === 'android'){
                if (this.isFileNameValid(event.target.files[0], 'android')){
                    this.androidFile = event.target.files[0];
                    this.isAndroidModelValid = true;
                }else {
                    this.isAndroidModelValid = false;
                }
            }
        }
    }

    // 检查模型文件扩展名是否合法
    isFileNameValid(files, prefix){
        const validIOSExtension = ['usdz'];
        const validAndroidExtension = ['gltf', 'glb'];
        try {
            const fileExtension = files.name.split('.')[1];
            if (prefix === 'ios' && validIOSExtension.includes(fileExtension)){
                return true;
            } else if (prefix === 'android' && validAndroidExtension.includes(fileExtension)){
                return true;
            } else {
                return false;
            }
        }catch (e) {
            return false;
        }

    }

    // 上传模型文件
    uploadModelFile(floorPlanId, prefix){
        if (prefix === 'ios'){
            this.isIOSUploading = true;
            const fd = new FormData();
            fd.append('file', this.iosFile);
            this.httpService.uploadArModel(floorPlanId, fd, prefix).subscribe((response: any) => {
                console.log(JSON.stringify(response));
                if (response.code === 1){
                    this.iosFile = '';
                    this.isIOSUploading = false;
                    this.toastrService.success('IOS model uploading successful');
                }else {
                    this.isIOSUploading = false;
                    this.toastrService.error('IOS model uploading failed');
                }
            });
        }
        if (prefix === 'android'){
            this.isAndroidUploading = true;
            const fd = new FormData();
            fd.append('file', this.androidFile);
            this.httpService.uploadArModel(floorPlanId, fd, prefix).subscribe((response: any) => {
                console.log(JSON.stringify(response));
                if (response.code === 1){
                    this.androidFile = '';
                    this.isAndroidUploading = false;
                    this.toastrService.success('Android model uploading successful');
                }else {
                    this.isAndroidUploading = false;
                    this.toastrService.error('Android model uploading failed');
                }
            });
        }

    }

}
